import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCapacityPlanRunSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateCapacityPlanRunSettingsInput;
}>;


export type UpdateCapacityPlanRunSettingsMutation = { __typename?: 'Mutation', updateCapacityPlanRunSettings: { __typename?: 'UpdateCapacityPlanRunSettingsPayload', capacityPlanRun?: { __typename?: 'CapacityPlanRun', id: any, status: Types.CapacityPlanRunStatus } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', message: string, code: Types.CapacityPlanErrorCode, runId?: any | null } | { __typename?: 'ValidationUserError', message: string }> | null } };


export const UpdateCapacityPlanRunSettingsDocument = gql`
    mutation UpdateCapacityPlanRunSettings($input: UpdateCapacityPlanRunSettingsInput!) {
  updateCapacityPlanRunSettings(input: $input) {
    capacityPlanRun {
      id
      status
    }
    errors {
      ... on Error {
        message
      }
      ... on CapacityPlanUserError {
        code
        runId
      }
    }
  }
}
    `;
export type UpdateCapacityPlanRunSettingsMutationFn = Apollo.MutationFunction<UpdateCapacityPlanRunSettingsMutation, UpdateCapacityPlanRunSettingsMutationVariables>;

/**
 * __useUpdateCapacityPlanRunSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCapacityPlanRunSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapacityPlanRunSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapacityPlanRunSettingsMutation, { data, loading, error }] = useUpdateCapacityPlanRunSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCapacityPlanRunSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapacityPlanRunSettingsMutation, UpdateCapacityPlanRunSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapacityPlanRunSettingsMutation, UpdateCapacityPlanRunSettingsMutationVariables>(UpdateCapacityPlanRunSettingsDocument, options);
      }
export type UpdateCapacityPlanRunSettingsMutationHookResult = ReturnType<typeof useUpdateCapacityPlanRunSettingsMutation>;
export type UpdateCapacityPlanRunSettingsMutationResult = Apollo.MutationResult<UpdateCapacityPlanRunSettingsMutation>;
export type UpdateCapacityPlanRunSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCapacityPlanRunSettingsMutation, UpdateCapacityPlanRunSettingsMutationVariables>;